import { Feature, FeatureCollection, Point } from 'geojson';
import { create, findNear, IPointToMeasure, remove, updateLocation } from '../../api/operation/pointToMeasure';
import SingletonEventEmitterClass from '../SingletonEventEmitterClass';

export default class PointToMeasureLoader extends SingletonEventEmitterClass {
  private _data: IPointToMeasure[] = [];
  private _editingPoint?: IPointToMeasure;

  public get geojson(): FeatureCollection<Point> {
    return {
      type: 'FeatureCollection',
      features: this._data.map<Feature<Point>>(pointToMeasure => {
        return {
          type: 'Feature',
          geometry: pointToMeasure.location.geometry,
          properties: {
            id: pointToMeasure._id,
            info: {
              ...pointToMeasure, layerType: 'pointToMeasure',
            },
          },
        };
      }),
    };
  }

  public onMapUpdatedCenter(center: ILngLat) {
    this._findPoints(center);
  }

  public onMapClick(lngLat: ILngLat) {
    this._addPoint(lngLat);
  }

  public onMapRightClick(id: string) {
    const point = this._data.find(row => row._id === id);
    if (point) {
      this._data.splice(this._data.indexOf(point), 1);
      this._removePoint(id);
    }
  }

  public onMapMouseDown(id: string) {
    const point = this._data.find(row => row._id === id);
    if (point) {
      this._editingPoint = point;
    }
  }

  public onMapMouseMove(lngLat: ILngLat) {
    if (this._editingPoint) {
      this._editingPoint.location.geometry.coordinates = lngLat;
      this._triggerPointsUpdated();
    }
  }

  public onMapMouseUp() {
    if (this._editingPoint) {
      this._updatePointLocation(this._editingPoint._id, this._editingPoint.location.geometry.coordinates as ILngLat);
      this._editingPoint = undefined;
    }
  }

  private _triggerPointsUpdated() {
    this.emit('points_updated');
  }

  private _addPoint(lngLat: ILngLat) {
    (async () => {
      const { data } = await create(lngLat);
      this._data.push(data);
      this._triggerPointsUpdated();
    })().catch(console.error);
  }

  private _removePoint(id: string) {
    (async () => {
      await remove(id);
      this._triggerPointsUpdated();
    })().catch(console.error);
  }

  private _updatePointLocation(id: string, lngLat: ILngLat) {
    (async () => {
      await updateLocation(id, lngLat, 'wgs84');
      this._triggerPointsUpdated();
    })();
  }

  private _findPoints(center: ILngLat) {
    (async () => {
      const { data } = await findNear(center, 1000, 'wgs84');
      this._data = data.filter(point => point.state === 0);
      this._triggerPointsUpdated();
    })().catch(console.error);
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/classes/loaders/PointToMeasureLoader.ts